import request from 'utils/request'

export const getMCAXS511InitRequest = () =>
  request({
    url: '/MCAXS511/init',
    method: 'post',
  })
